import { Workspace } from "effno-core";
import { getRequest, postRequest, deleteRequest } from "./client";

import config from "environment";

const { baseApi } = config;

export async function apiSetCurrentWorkspace(id: string, workspaceId: string) {
    const fetchURL = `${baseApi}/users/set-workspace`;
    return await postRequest(
      fetchURL,
      { id, workspaceId },
      "API/apiSetCurrentWorkspace"
    );
}
  

export async function apiCreateWorkspaceForUser(name: string, userId: string) : Promise<Workspace | null> {
    const fetchURL = `${baseApi}/workspaces/create-for-user`;
    return await postRequest(
      fetchURL,
      { name, userId },
      "API/apiCreateWorkspaceWithUser"
    );
}
  
export async function apiGetWorkspace(workspaceId: string) : Promise<Workspace | null> {
    const fetchURL = `${baseApi}/workspaces/${workspaceId}`;
    return await getRequest(fetchURL, "API/apiGetWorkspace");
}
  
export async function apiUpdateWorkspace(workspace: Workspace) {
    const fetchURL = `${baseApi}/workspaces/update`;
    return await postRequest(
      fetchURL,
      { ...workspace },
      "API/apiUpdateWorkspace"
    );
}
  
export async function apiLeaveWorkspace(workspaceId: string, userId: string) {
    const fetchURL = `${baseApi}/workspaces/${workspaceId}/leave/${userId}`;
    return await getRequest(fetchURL, "API/apiLeaveWorkspace");
}
  
export async function apiAddInvite(invitedByUserId: string, workspaceId: string, email: string) {
    const fetchURL = `${baseApi}/invite/create`;
    return await postRequest(
      fetchURL,
      { invitedByUserId, workspaceId, email },
      "API/apiAddInvite"
    );
}
  
export async function apiDeleteInvite(inviteId: string) {
    const fetchURL = `${baseApi}/invite/${inviteId}`;
    return await deleteRequest(fetchURL, "API/apiDeleteInvite");
}
  
export async function apiResendInvite(inviteId: string) {
    const fetchURL = `${baseApi}/invite/resend/${inviteId}`;
    return await getRequest(fetchURL, "API/apiResendInvite");
}
  
export async function apiAddWorkspaceUser(workspaceId: string, id: string) {
    const fetchURL = `${baseApi}/workspaces/add-user`;
    return await postRequest(
      fetchURL,
      { workspaceId, id },
      "API/apiAddWorkspaceUser"
    );
}
  
export async function apiRemoveWorkspaceUser(workspaceId: string, id: string) {
    const fetchURL = `${baseApi}/workspaces/remove-user`;
    return await postRequest(
      fetchURL,
      { workspaceId, id },
      "API/apiRemoveWorkspaceUser"
    );
}
  
export async function apiDeleteWorkspace(workspaceId: string) {
    const fetchURL = `${baseApi}/workspaces/delete/${workspaceId}`;
    return await getRequest(fetchURL, "API/apiDeleteWorkspace");
}
  
export async function apiGetWorkspaceUsers(workspaceId: string) {
    const fetchURL = `${baseApi}/workspaces/users/${workspaceId}`;
    return await getRequest(fetchURL, "API/apiGetWorkspaceUsers");
}
  
export async function apiGetWorkspaceInvites(workspaceId: string) {
    const fetchURL = `${baseApi}/workspaces/invites/${workspaceId}`;
    return await getRequest(fetchURL, "API/apiGetWorkspaceInvites");
}